import { render } from "./ContentCardFull.vue?vue&type=template&id=5199cef2&scoped=true"
const script = {}

import "./ContentCardFull.vue?vue&type=style&index=0&id=5199cef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5199cef2"]])

export default __exports__